import { useIsFetching, useQueryClient, } from "@tanstack/react-query";
import { random } from "lodash";
import { useEffect, useState } from "react";
import { debugLog } from "../logger";
export default function usePrefetchQuery(options, type = "prefetch", enabled = true) {
    const queryClient = useQueryClient();
    const isFetching = useIsFetching();
    const [preFetchStarted, setPrefetchStarted] = useState(false);
    useEffect(() => {
        if (!enabled) {
            return;
        }
        if (type === "preload") {
            if (process.env.NODE_ENV === "development" || // react-native
                process.env.NODE_ENV === "dev" // react
            ) {
                debugLog("Preloading", JSON.stringify(options.queryKey));
            }
            queryClient.prefetchQuery(options);
            return;
        }
        // randomly jitter so we only do 1 prefetch at a time and allow higher priority data
        // requests to be uncontested if user navigates around to a new screen that needs to fetch
        const randomJitterMs = random(500, 3000);
        let cancelFn = () => undefined;
        // Only start prefetching if we have no active fetches
        if (isFetching === 0 && preFetchStarted === false) {
            // we use JS Closures to not cancel an already in-flight request
            let canCancel = true;
            const timeout = setTimeout(() => {
                canCancel = false;
                setPrefetchStarted(true);
                if (process.env.NODE_ENV === "development" || // react-native
                    process.env.NODE_ENV === "dev" // react
                ) {
                    debugLog("Preloading", JSON.stringify(options.queryKey));
                }
                void queryClient.prefetchQuery(options);
            }, randomJitterMs);
            // if new fetches start, cancel this prefetch and wait for idle network again
            cancelFn = () => {
                if (!canCancel) {
                    return;
                }
                clearTimeout(timeout);
            };
        }
        return cancelFn;
    }, [isFetching, queryClient, options, type, enabled, preFetchStarted]);
    if (options.queryKey) {
        return queryClient.getQueryState(options.queryKey)?.status ?? "Unknown";
    }
    if (!enabled) {
        return "Disabled";
    }
    return "Unknown";
}
//# sourceMappingURL=usePrefetchQuery.js.map